var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Phone",
    clipPath: "url(#clip0_231_5983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.683 5.341C5.15217 6.16524 5.83476 6.84783 6.659 7.317L7.101 6.698C7.17208 6.59847 7.27717 6.52844 7.3964 6.50117C7.51563 6.47389 7.64072 6.49127 7.748 6.55C8.45516 6.93646 9.2361 7.16889 10.0395 7.232C10.1649 7.24194 10.2819 7.29877 10.3673 7.39116C10.4526 7.48355 10.5 7.60472 10.5 7.7305V9.9615C10.5 10.0853 10.4541 10.2047 10.3712 10.2966C10.2882 10.3885 10.1742 10.4464 10.051 10.459C9.786 10.4865 9.519 10.5 9.25 10.5C4.97 10.5 1.5 7.03 1.5 2.75C1.5 2.481 1.5135 2.214 1.541 1.949C1.55363 1.82585 1.61149 1.71176 1.70339 1.62882C1.7953 1.54587 1.9147 1.49997 2.0385 1.5H4.2695C4.39528 1.49998 4.51645 1.54738 4.60884 1.63273C4.70123 1.71807 4.75806 1.83511 4.768 1.9605C4.83111 2.7639 5.06354 3.54484 5.45 4.252C5.50873 4.35928 5.52611 4.48437 5.49883 4.6036C5.47156 4.72282 5.40153 4.82792 5.302 4.899L4.683 5.341ZM3.422 5.0125L4.372 4.334C4.10239 3.75205 3.91768 3.13442 3.8235 2.5H2.505C2.502 2.583 2.5005 2.6665 2.5005 2.75C2.5 6.478 5.522 9.5 9.25 9.5C9.3335 9.5 9.417 9.4985 9.5 9.495V8.1765C8.86558 8.08232 8.24795 7.89761 7.666 7.628L6.9875 8.578C6.71433 8.47186 6.449 8.34655 6.1935 8.203L6.1645 8.1865C5.18379 7.62836 4.37164 6.81621 3.8135 5.8355L3.797 5.8065C3.65345 5.551 3.52814 5.28567 3.422 5.0125Z",
    fill: "#CE6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_5983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone_call.9fc0bc60cf1d12532164f8f6d6fdc36c.svg";
export { ForwardRef as ReactComponent };